import http from '../widget-http'

export default class WidgetAuthServices {
  async authenticate(data) {
    let res = await http.post(`v1/widget/auth`, data);
    return res.data;
  }
}